export { hyphenateSync } from "hyphen/en-us";
